import moment from 'moment';

const BlackoutPeriodPreviewColumn = [
  {
    title: 'Webpage URL',
    dataIndex: 'urls',
    slot: 'urls',
    width: 250,
  },
  {
    title: 'Start Date/Time',
    dataIndex: 'start',
    slot: 'start',
    sorter: (a, b) => moment(a.start).diff(moment(b.start)),
    width: 200,
  },
  {
    title: 'End Date/Time',
    dataIndex: 'end',
    slot: 'end',
    sorter: (a, b) => moment(a.end).diff(moment(b.end)),
    width: 200,
  },
];

export { BlackoutPeriodPreviewColumn };
